export const automationFrameworksModule = {
  id: "automation-frameworks-enterprise",
  title: "Test Automation Frameworks",
  description: "Master modern test automation frameworks and tools for enterprise applications.",
  content: `## Overview\nLearn to implement robust test automation using industry-standard frameworks like Jest, Cypress, Selenium, and Playwright for comprehensive test coverage.`,
  duration: 90
};